import React, { Fragment } from 'react'

export default function getFormStatus (state, props={ })
{
	const form_status =
	[
		{ label: 'info', suffix: '--green' },
		{ label: 'warning', suffix: '--orange' },
		{ label: 'error', suffix: '--red' },
		{ label: 'statement', suffix: '--blue' }
	];

/**
 * Map all status from component.state and return information messages accordingly.
 *
 * @param    { Object }    status_data    Infos messages to display.
 * @param    { String }    index          Iteratof.
 *
 * @return    [Array]      Renderable React elements.
 */
	let status = form_status
	.filter(status_data => typeof state[status_data.label] !== 'undefined')
	.map(function (status_data, index)
	{
		var message =
		(
			<div key={ index } className={ 'c-form-message ' +
				'c-form-message' + status_data.suffix } style={ props.style }>
				<div className="c-form-message__content">
					{
						state[status_data.label]?.includes?.('\n') === false
						? state[status_data.label]
						: state[status_data.label].split('\n')
						.map(function (chunk, i)
						{
							return (
								<div key={ i + '##' + chunk }>{ chunk }</div>
							);
						})
					}
				</div>
			</div>
		);

		return message;
	});

	return status;
}